// @flow
import { combineReducers } from 'redux';
import { AsyncRequest } from 'angieslist-app-platform';
import actionKeys from '../../../app/common/service-area/serviceAreaMapActionKeys';
import type { AsyncState } from '../../../app/types';

export type GetCityDetailsRequest = {
  cityId: number,
};

export type GetCityDetailsResponse = {
  postalCodes: Array<string>,
};

export type ServiceAreaMapReducerState = {|
  citySearch: AsyncState<{}, any>,
  cityDetails: AsyncState<GetCityDetailsRequest, GetCityDetailsResponse>,
  setServiceArea: AsyncState<{}, void>,
|};

export default (combineReducers({
  citySearch: AsyncRequest.createReducer(actionKeys.SEARCH_CITIES),
  cityDetails: AsyncRequest.createReducer(actionKeys.GET_CITY_DETAILS),
  setServiceArea: AsyncRequest.createReducer(actionKeys.SET_SERVICE_AREA),
}): any);



// WEBPACK FOOTER //
// ./src/modules/home/common/serviceAreaMapReducer.js